import axiosLib from 'axios';
import qs from 'qs';
import StorageHelper from 'Src/helpers/storage/storage';

const axios = (axiosLib as any).default || axiosLib;

const axiosInstance = axios.create({
  paramsSerializer: (params) => qs.stringify(params, { allowDots: false, encode: false, depth: 20 } as any)
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status >= 400) {
      const status = error.response.status;
      const method = String(error.config?.method || 'request').toUpperCase();
      const url = error.config?.url || 'unknown URL';
      const details = error.response?.data?.details?.text || error.response?.data?.message || '';
      error.message = `${status} ${method} ${url}${details ? `: ${details}` : ''}`;
      console.error(`[API ${status}]`, method, url, error.response?.data);
    }

    if (error.response && error.response.status === 401 && !error.config?.skipAuthRedirect) {
      StorageHelper.SessionStorage.remove('activeSchoolId');
      StorageHelper.SessionStorage.remove('activeSchoolName');
      StorageHelper.SessionStorage.remove('roleSession');
      StorageHelper.SessionStorage.remove('activePermission');
      StorageHelper.Cookie.remove('loginSession');
      StorageHelper.Cookie.remove('loginSession', { domain: '.squadintouch.com' });
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
